import * as React from 'react';
import clsx from 'clsx';
import './style.css';

type Props = {
	level?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
	color?: string;
	className?: string;
	children: string | string[] | JSX.Element | JSX.Element[];
	innerHtml?: boolean;
	size?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
	style?: Record<string, unknown> | {};
};

export const Heading = ({
	level = 'h1',
	color = 'text-ep-navy',
	className,
	size,
	children,
	style,
	innerHtml = false,
}: Props) => {
	const Tag = ({ ...props }: React.HTMLAttributes<HTMLHeadingElement>) =>
		React.createElement(level, props, children);

	return (
		<Tag
			className={clsx(
				'heading',
				color,
				{ 'text-subhead': !className?.includes('text-body') && level !== 'h1' },
				{ 'font-medium leading-tighter': !!size && size !== 'h1' },
				{ 'mb-0': !className?.includes('mb-0') },
				className
			)}
			style={style}
		>
			{children}
		</Tag>
	);
};
